/**
 * PATH: packages/email-hub/src/feature/reader-header/adapters/FullReaderHeaderAdapter.tsx
 * FILE_ID: EMAILHUB-READERHEADER-ADAPTER-FULL-001
 * PURPOSE: Enforce full-view invariants over the shared adapter frame.
 * ROLE IN ARCHITECTURE: Public adapter the full reader mounts (plan Phase 1).
 * MAIN EXPORTS: FullReaderHeaderAdapter, FullReaderHeaderAdapterProps.
 * NON-RESPONSIBILITIES: No `expand` (already full view); header behavior must
 *   never fork from preview — both delegate to the same ReaderHeaderAdapter.
 * NOTES FOR FUTURE AI: Zoom is required here because the registry gates
 *   zoom actions to `surface === 'full'`.
 */
import { ReaderHeaderAdapter } from './ReaderHeaderAdapter'
import type {
  ReaderHeaderHostBindings,
  ReaderHeaderZoomBindings,
} from './types'

export type FullReaderHeaderAdapterProps = Omit<
  ReaderHeaderHostBindings,
  'surface' | 'onExpand' | 'zoom'
> & {
  zoom: ReaderHeaderZoomBindings
}

export function FullReaderHeaderAdapter(props: FullReaderHeaderAdapterProps) {
  return <ReaderHeaderAdapter {...props} surface="full" />
}
